import {
  ODataHeader,
  ODataString,
  ODataInteger,
  ODataBoolean,
  ODataDate,
  ODataDecimal
} from "pbas-vue-components";

const formatter = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
  minimumFractionDigits: 2
});

var SickDaySubmissionSettingsHeaders =
   [
    new ODataHeader({
      type: new ODataString("Id"),
      visible: false,
      allowVisibilityChange: false,
      searchable: false,
      isIdentifier: true,
    }),
    new ODataHeader({
      type: new ODataString("PlanId"),
      visible: false,
      allowVisibilityChange: false,
      searchable: false,
    }),
    new ODataHeader({
      title: "globals.plan",
      type: new ODataString("Plan/Number"),
      sortable: true,
      visible: true,
      searchable: true,
    }),
    new ODataHeader({
      type: new ODataString("MemberGroupId"),
      visible: false,
      allowVisibilityChange: false,
      searchable: false,
    }),
    new ODataHeader({
      title: "globals.effective_date",
      type: new ODataDate("EffectiveDate"),
      sortable: true,
      visible: true,
      allowVisibilityChange: true,
      searchable: true,
     }),
    // new ODataHeader({
    //   title: "headers.sick_payment_settings.maximum_accumulated_hours",
    //   type: new ODataInteger("MaximumAccumulatedHours"),
    //   visible: true,
    //   allowVisibilityChange: true,
    //   searchable: true,
    //   sortable: true,
    // }),
    new ODataHeader({
      title: "headers.sick_payment_settings.maximum_days_per_claim_submission",
      type: new ODataInteger("MaximumDaysPerClaimSubmission"),
      visible: true,
      allowVisibilityChange: true,
      searchable: true,
      sortable: true,
    }),
    // new ODataHeader({
    //   title: "headers.sick_payment_settings.hours_per_sick_day",
    //   type: new ODataInteger("HoursPerSickDay"),
    //   visible: true,
    //   allowVisibilityChange: true,
    //   searchable: true,
    //   sortable: true,
    // }),
    // new ODataHeader({
    //   title: "headers.sick_payment_settings.supports_half_days",
    //   type: new ODataBoolean("SupportsHalfDays"),
    //   visible: true,
    //   allowVisibilityChange: true,
    //   searchable: true,
    //   sortable: true,
    // }),
    new ODataHeader({
      title: "headers.sick_payment_settings.half_day_percentage",
      type: new ODataDecimal("HalfDayPercentage"),
      visible: true,
      allowVisibilityChange: true,
      searchable: true,
      sortable: true,
    }),
    new ODataHeader({
      title: "headers.sick_payment_settings.requires_doctors_note",
      type: new ODataBoolean("RequiresDoctorsNote"),
      visible: true,
      allowVisibilityChange: true,
      searchable: true,
      sortable: true,
    }),
    new ODataHeader({
      title: "headers.sick_payment_settings.requires_sick_day_form",
      type: new ODataBoolean("RequiresSickDayForm"),
      visible: true,
      allowVisibilityChange: true,
      searchable: true,
      sortable: true,
    }),
    // new ODataHeader({
    //   title: "headers.sick_payment_settings.requires_employer_confirmation",
    //   type: new ODataBoolean("RequiresEmployerConfirmation"),
    //   visible: true,
    //   allowVisibilityChange: true,
    //   searchable: true,
    //   sortable: true,
    // }),
  ];


export default SickDaySubmissionSettingsHeaders;
